import { createJSONStorage } from 'zustand/middleware';
import { AES, enc } from 'crypto-js';

export const encrypt = (value: string) => {
  const secureKey = import.meta.env.VITE_STORE_SECURE_KEY;
  return AES.encrypt(value, secureKey).toString();
};

export const decrypt = (value: string) => {
  const secureKey = import.meta.env.VITE_STORE_SECURE_KEY;
  return AES.decrypt(value, secureKey).toString(enc.Utf8);
};

export const encryptJSONStorage = () =>
  createJSONStorage(() => {
    return !import.meta.env.DEV
      ? {
          setItem(name: string, value: string) {
            return localStorage.setItem(name, encrypt(value));
          },
          getItem(name: string) {
            return decrypt(localStorage.getItem(name) ?? '');
          },
          removeItem(name: string) {
            return localStorage.removeItem(name);
          },
        }
      : localStorage;
  });
